import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Method, serializeQueryParis } from '@/fetch/core/util';
import {
  EVENTTYPE,
  ThreeDimensionTaskState,
  VideoState,
  VideoDirection,
} from '@/utils/constant';
import { analyzeLog } from '@/utils/util';
import { Popover, Tooltip, message, Modal } from 'antd';
import React, { useState, useRef, useEffect } from 'react';
import './index.scss';
import { showModal } from '@/components/Common/Modal';
import SimpleMap from '@/views/ShadowSystem/components/SimpleMap';
import FieldsGroup, { FieldsGroupProps } from '@/components/FieldGroup';
import { isEmpty, transformLocationWgs84togcj02 } from '@/utils';
import { getFieldsGroupData } from '@/views/ShadowSystem/util';
import ErrorMessage from '@/components/ErrorMessage';
import ShadowSystemApi from '@/fetch/bussiness/shadow';
import ThreeMonitor from '@/components/XMonitor/Monitor/ThreeMonitor';
import ControlerBar from '@/views/EventPlayBack/ControlerBar';
import { useSelector } from 'react-redux';
import FlvPlayer from '@/components/FlvPlayer';
type PopoverListBtnProps = {
  id: string | number;
  type: string;
  btnText: string;
  className?: string;
  onClick?: AnyFunc;
};

const requestApi = new ShadowSystemApi();
const PopoverListBtn = (props: PopoverListBtnProps) => {
  const login = useSelector((state: any) => state.login);
  const inverseAdrressRef = useRef<any>(null);
  const [rowId, setRowId] = useState<number | null>(null);
  const shadowDetailRef = useRef<any>(null);
  const _interval = useRef<any>(null);
  const _timeout = useRef<any>(null);
  const _eventStartTime = useRef<number>(0);
  const _eventEndTime = useRef<number>(0);
  const _localViewRef = useRef<any>(null);

  const [eventDuration, setEventDuration] = useState<number>(0);
  const [eventCurrentTime, setEventCurrentTime] = useState<number>(-100);
  const [newEventStartTime, setNewEventStartTime] = useState<number>(0);
  const [isEventPaused, setIsEventPaused] = useState<boolean>(true);
  const [localViewVisible, setLocalViewVisible] = useState<boolean>(false);
  const [vehicleName, setVechcleName] = useState<string>('');
  const [reportTime, setReportTime] = useState<string>('');
  const [list, setList] = useState<
    {
      text: string;
      value: string | number;
      enable: boolean;
    }[]
  >([]);
  const { id, btnText, type } = props;

  useEffect(() => {
    if (eventCurrentTime >= eventDuration) {
      setIsEventPaused(true);
      clearInterval(_interval.current);
      setNewEventStartTime(_eventStartTime.current + eventCurrentTime);
      return;
    }

    if (_localViewRef.current && localViewVisible) {
      window.addEventListener('keyup', onPressSpace);
      window.addEventListener('blur', handleWindowBlur);
      window.addEventListener('focus', handleWindowFocus);
    }
    return () => {
      window.removeEventListener('keyup', onPressSpace);
      window.removeEventListener('blur', handleWindowBlur);
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, [eventCurrentTime, isEventPaused, localViewVisible]);

  const getRealtimeData = async (id: string) => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: `/shadow/web/realtime/${type}`,
      body: {
        id,
      },
    };
    const res: any = await request(requestParam);
    return res;
  };

  const handleFieldItemClick = (detailData: any, itemKey: string) => {
    if (itemKey === 'inverseAddress') {
      showModal({
        width: 1080,
        title: `定位地址-${detailData.vehicleName}-${detailData.reportTime}`,
        content: (
          <SimpleMap
            lon={inverseAdrressRef.current?.lon}
            lat={inverseAdrressRef.current?.lat}
          />
        ),
        footer: null,
        onClose: () => {
          previewRealtimeData(detailData);
        },
      });

      analyzeLog(
        'inverseAddress',
        `{"lonLatStr":${inverseAdrressRef.current?.lon}_${inverseAdrressRef.current?.lat}}`,
      );
    }
  };

  const previewRealtimeData = async (detailData: any) => {
    const res = await getRealtimeData(detailData.id);
    if (res.code === HttpStatusCode.Success) {
      const { lat, lon, exceptionList } = res?.data || {};
      inverseAdrressRef.current = transformLocationWgs84togcj02({
        lon,
        lat,
      });
      const latLonStr = `${inverseAdrressRef.current.lat},${inverseAdrressRef.current.lon}`;
      const inverseAddress: any = await requestApi.getInverseAddress(latLonStr);
      const fieldsGroup = getFieldsGroupData({
        ...res.data,
        inverseAddress: inverseAddress?.formatted_addresses?.recommend,
      });
      showModal({
        width: 1080,
        title: `车辆实时数据-${detailData.vehicleName}-${detailData.reportTime}`,
        content: (
          <div className='group-wrapper'>
            {fieldsGroup.map((item: FieldsGroupProps, index: number) => (
              <FieldsGroup
                {...item}
                key={index}
                handleClickItem={handleFieldItemClick.bind(null, detailData)}
              />
            ))}
            <div className='error-list'>
              <div className='title-tag'>错误信息</div>
              <ErrorMessage errorList={exceptionList} />
            </div>
          </div>
        ),
        footer: null,
      });
    } else {
      message.error(res.message || '车辆实时数据获取失败，请重试！');
    }
  };

  const getEventStatus = async () => {
    const requestParam: RequestOptions = {
      path: '/shadow/web/event/detail',
      method: Method.POST,
      body: {
        eventId: id,
      },
    };
    const res: any = await request(requestParam);
    return res;
  };

  const onPressSpace = (e: KeyboardEvent) => {
    if (e.code === 'Space') {
      if (isEventPaused) {
        handleEventPlay();
      } else {
        handleEventPause();
      }
    }
  };

  const handleEventPlay = () => {
    clearInterval(_interval.current);
    if (eventCurrentTime > 0 && eventCurrentTime < eventDuration) {
      setNewEventStartTime(_eventStartTime.current + eventCurrentTime);
    } else {
      setNewEventStartTime(_eventStartTime.current);
      setEventCurrentTime((eventCurrentTime) => (eventCurrentTime = -100));
    }
    _interval.current = setInterval(() => {
      setEventCurrentTime((eventCurrentTime) => eventCurrentTime + 100);
    }, 100);
    setIsEventPaused(false);
  };
  const handleEventPause = () => {
    clearInterval(_interval.current);
    setIsEventPaused(true);
    setNewEventStartTime(_eventStartTime.current + eventCurrentTime);
  };
  const handleControlChange = (value: any) => {
    setEventCurrentTime(value);
    clearInterval(_interval.current);
    setNewEventStartTime(_eventStartTime.current + value);
    setIsEventPaused(true);
  };
  const handleCloseLocalView = () => {
    clearInterval(_interval.current);
    setIsEventPaused(true);
    setEventCurrentTime(-100);
    setEventDuration(0);
    _eventStartTime.current = 0;
    _eventEndTime.current = 0;
    setLocalViewVisible(false);
    setNewEventStartTime(0);
  };

  const previewLocalView = async (detailData: any) => {
    if (
      shadowDetailRef.current?.thirdDimensionTaskState !==
      ThreeDimensionTaskState.SUCCESS
    ) {
      message.warning('3D合成中');
      return;
    } else {
      setVechcleName(detailData.vehicleName);
      setReportTime(detailData.reportTime);
      const shadowRes = await requestApi.getEventLinkView(type, detailData.id);
      if (shadowRes.code === HttpStatusCode.Success) {
        _eventStartTime.current = new Date(
          shadowRes?.data?.startTime,
        ).getTime();
        _eventEndTime.current = new Date(shadowRes?.data?.endTime).getTime();

        setEventDuration((eventDuration) => {
          return _eventEndTime.current - _eventStartTime.current;
        });
        setLocalViewVisible(true);
        handleEventPlay();
      } else {
        message.error('3D信息获取失败');
        return;
      }
    }
  };

  const handleWindowBlur = (e: FocusEvent) => {
    clearTimeout(_timeout.current);
    _timeout.current = setTimeout(() => {
      handleCloseLocalView();
    }, 120000);
  };
  const handleWindowFocus = (e: FocusEvent) => {
    clearTimeout(_timeout.current);
  };
  const handleCopyVideoUrl = (url: string) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
      message.success('链接复制成功');
    }
  };

  const handlePlayVideo = async (detailData: any) => {
    if (shadowDetailRef.current?.videoState === VideoState.FINISH) {
      const requestParam: RequestOptions = {
        method: 'POST',
        path: `/shadow/web/video/view`,
        body: {
          id: detailData.id,
          type,
        },
      };

      const res: any = await request(requestParam);
      if (res.code === HttpStatusCode.Success) {
        showModal({
          width: 1080,
          title: (
            <>
              <span>
                四路视频-{detailData.vehicleName}-{detailData.reportTime}
              </span>
              <Tooltip title='请注意不要将链接或视频暴露于公共环境，以防机密信息泄露'>
                <i
                  className='copy-btn'
                  onClick={handleCopyVideoUrl.bind(null, res.data)}
                >
                  复制分享链接
                </i>
              </Tooltip>
            </>
          ),
          content: (
            <video width={'100%'} src={res.data} autoPlay controls></video>
          ),
          footer: null,
        });
      } else {
        message.error(res.message || '播放地址获取失败');
      }
    } else {
      message.warning('视频正在制作中，请稍后获取');
    }
  };
  const handleEventPlayBack = async (detailData: any) => {
    if (
      shadowDetailRef.current?.thirdDimensionTaskState !==
        ThreeDimensionTaskState.SUCCESS ||
      shadowDetailRef.current?.videoState !== VideoState.FINISH
    ) {
      message.warning('数据正在合成中，请稍后回放');
      return;
    }
    const { id, vehicleName, reportTime } = detailData;
    const urlParamStr = serializeQueryParis({
      eventId: id,
      vehicleName,
      reportTime: encodeURIComponent(reportTime),
      eventType: EVENTTYPE.EVENT,
    });
    const url = '/app/eventplayback?' + urlParamStr;
    window.open(url, '_blank');
  };
  const getDirectionVideoData = (data: any, direction: string) => {
    switch (direction) {
      case 'FRONT':
        return isEmpty(data.frontVideos) ? [] : data.frontVideos;
      case 'BACK':
        return isEmpty(data.backVideos) ? [] : data.backVideos;
      case 'LEFT':
        return isEmpty(data.leftVideos) ? [] : data.leftVideos;
      case 'RIGHT':
        return isEmpty(data.rightVideos) ? [] : data.rightVideos;
      default:
        return [];
    }
  };
  /**
   * 查看方向视频
   */
  const handlePlayDirectionCamVideo = async (
    rowData: any,
    direction: string,
  ) => {
    const res = await requestApi.getDirectionCamPlayBackUrl({
      terminalId: rowData.vehicleName,
      direction: direction,
      startTimeStr: rowData.reportTime,
      operator: login.userName,
    });
    if (res.code === HttpStatusCode.Success) {
      const videoData = getDirectionVideoData(res.data, direction);
      if (isEmpty(videoData)) {
        message.warning('无视频记录');
      } else {
        showModal({
          width: 640,
          title: (
            <>
              <span>
                {VideoDirection.get(direction)}-{rowData.vehicleName}-
                {rowData.reportTime}
              </span>
              <Tooltip title='请注意不要将链接或视频暴露于公共环境，以防机密信息泄露'>
                <i
                  className='copy-btn'
                  onClick={handleCopyVideoUrl.bind(
                    null,
                    videoData[0].publicUrl,
                  )}
                >
                  复制分享链接
                </i>
              </Tooltip>
            </>
          ),
          content: <FlvPlayer url={videoData[0]?.publicUrl} />,
          footer: null,
        });
      }
    } else {
      message.error('播放地址获取失败');
    }
  };
  const fetchListBtnData = async () => {
    const res = await getEventStatus();
    if (res.code === HttpStatusCode.Success) {
      shadowDetailRef.current = res?.data;
      const { id, realtimeId, videoTaskId, thirdDimensionTaskState } =
        res?.data || {};
      const btnList = [
        {
          value: 'realtimeData',
          text: '查看车辆数据',
          enable: realtimeId != null,
          handleClick: previewRealtimeData.bind(null, res?.data),
        },
        {
          value: 'localview',
          text: '查看3d',
          enable: thirdDimensionTaskState != null,
          handleClick: previewLocalView.bind(null, res?.data),
        },
        {
          value: 'frontCam',
          text: '查看前路视频',
          enable: true,
          handleClick: handlePlayDirectionCamVideo.bind(
            null,
            res?.data,
            'FRONT',
          ),
        },
        {
          value: 'backCam',
          text: '查看后路视频',
          enable: true,
          handleClick: handlePlayDirectionCamVideo.bind(
            null,
            res?.data,
            'BACK',
          ),
        },
        {
          value: 'leftCam',
          text: '查看左路视频',
          enable: true,
          handleClick: handlePlayDirectionCamVideo.bind(
            null,
            res?.data,
            'LEFT',
          ),
        },
        {
          value: 'rightCam',
          text: '查看右路视频',
          enable: true,
          handleClick: handlePlayDirectionCamVideo.bind(
            null,
            res?.data,
            'RIGHT',
          ),
        },
        {
          value: 'video',
          text: '查看四路视频',
          enable: videoTaskId != null,
          handleClick: handlePlayVideo.bind(null, res?.data),
        },
        {
          value: 'eventPlayBack',
          text: '查看整车回放',
          enable: videoTaskId != null && thirdDimensionTaskState != null,
          handleClick: handleEventPlayBack.bind(null, res?.data),
        },
      ];
      setList(btnList);
      setRowId(id);
    }
  };

  return (
    <>
      <Popover
        onOpenChange={(visible: boolean) => {
          if (visible) {
            fetchListBtnData();
          }
        }}
        content={
          <div className='row-popover'>
            {list.map((item: any) => (
              <div
                className='row-popover_btn'
                key={item.value + id}
                onClick={item.enable ? item.handleClick : null}
                style={{
                  opacity: `${item.enable ? 1 : 0.4}`,
                }}
              >
                {item.text}
              </div>
            ))}
          </div>
        }
        trigger='hover'
      >
        <span className='row-btn'>{btnText}</span>
      </Popover>
      <Modal
        width={1300}
        title={`3D模块-${vehicleName}-${reportTime}`}
        footer={null}
        onCancel={handleCloseLocalView}
        visible={localViewVisible}
        destroyOnHidden={true}
        maskClosable={false}
      >
        <div
          style={{
            height: '600px',
            width: '100%',
          }}
          ref={_localViewRef}
        >
          {_localViewRef.current && (
            <>
              <ThreeMonitor
                elementId='popover-WebGL-output'
                carNumber={vehicleName}
                url={process.env.JDX_APP_SHADOW_MONITOR_URL + '/local_views'}
                hiddenDelay={true}
                openData={{
                  eventType: 'LOCAL_VIEW',
                  data: {
                    eventId: rowId,
                    eventType: type,
                    rate: 100,
                  },
                }}
                sendData={{
                  eventType: 'LOCAL_VIEW',
                  data: {
                    eventId: rowId,
                    eventType: type,
                    rate: 100,
                    startTime: newEventStartTime,
                    pause: isEventPaused,
                  },
                }}
              />
              <ControlerBar
                currentTime={eventCurrentTime}
                duration={eventDuration}
                isPaused={isEventPaused}
                handleEventPlay={handleEventPlay}
                handleEventPause={handleEventPause}
                handleControlChange={handleControlChange}
                extraBtn={null}
              />
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default React.memo(PopoverListBtn);
